/**
 * Converte valores monetários brasileiros colados de extratos bancários.
 * Ex.: "R$ 382,05", "-R$ 1.262,44", "1262.44"
 */
export function parseBrazilianCurrency(input) {
  if (input == null || input === "") {
    return { amount: null, isNegative: false };
  }

  let str = String(input).trim();
  const isNegative = /-\s*R?\$?|^\(.*\)$/.test(str) || str.startsWith("-");

  str = str
    .replace(/[()]/g, "")
    .replace(/R\$\s?/gi, "")
    .replace(/\s/g, "")
    .replace(/^-/, "");

  if (str.includes(",")) {
    str = str.replace(/\./g, "").replace(",", ".");
  }

  const parsed = parseFloat(str);
  if (isNaN(parsed)) {
    return { amount: null, isNegative: false };
  }

  return {
    amount: Math.abs(parsed),
    isNegative: isNegative || parsed < 0,
  };
}
